import React from "react";
import { useAppDispatch, useAppSelector } from "src/store/store";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import ModelFieldList from "src/components/shared/titleAndButton/modelFieldList";
import { setSelectedFieldId } from "src/store/modelManagementSlice";

const FieldRecords = () => {
  const dispatch = useAppDispatch();
  const { selectedModelId, selectedModel, selectedFieldId } = useAppSelector(
    (state) => state.modelSlice,
  );

  return selectedModelId === "" ? (
    <Column height={"60%"} alignmentVertical={"center"} alignmentHorizontal={"center"}>
      <Text>Please select your model</Text>
    </Column>
  ) : (
    <Column spacing={"300"}>
      {Object.values(selectedModel.fields).map((field) => (
        <ModelFieldList
          record={field}
          onClick={() => {
            dispatch(setSelectedFieldId(field.id));
          }}
        />
      ))}
    </Column>
  );
};

export default FieldRecords;
